<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>Service Status</h2>
  </div>
</div>

<div class="row">

  <div class="col-md-6">
    <div class="panel panel-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-tint payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Status</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body status-content top-container">
          <strong>Your Water Service is: </strong> <strong class="green">ON</strong>
          <ul class="list-unstyled margin-top-bottom-10">
            <li>{{streetAddress}}</li>
            <li>{{cityStateZip}}</li>
            <li>{{acctNumber}}</li>
          </ul>
          <div class="bottom-blue-border"></div>
          <div class="row">
            <div class="col-sm-12">
              <input *ngIf="showIssueButton" type="button" (click)="reportIssue()" class="btn btn-danger col-12" value="Report a Water Service Issue" />
              <label *ngIf="!showIssueButton" class="green col-12">Message succesfully sent to our support team, someone will be in contact with you soon.</label>
            </div>
            <div class="col-sm-12" *ngIf="showReportIssue">
              <textarea rows="3" class="form-control margin-top-bottom-10" [(ngModel)]="issueMessage"></textarea>
              <input type="button" (click)="reportOutage(currentAccount, issueMessage)" class="btn btn-primary col-12 float-right" value="Submit" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dx-toast [(visible)]="showSuccess"
            type="success"
            message="Request to close and disconnect your water serivce was succesful.">
  </dx-toast>

  <dx-toast [(visible)]="showError"
            type="error"
            message="{{error}}">
  </dx-toast>

  <dx-toast [(visible)]="showSuccessReport"
            type="success"
            message="An email reporting your outage has been successfully sent to our support team.">
  </dx-toast>

  <div class="col-md-6">
    <div class="panel panel-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-exclamation-circle payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">My Alerts</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body status-content top-container">
          <span>Phone Numbers in Use (Text Alerts):</span>
          <br />
          <ul class="list-group" *ngIf="hasAlarmPhone">
            <li *ngFor="let phone of phoneNums" class="list-group-item">
              {{ phone }}
            </li>
          </ul>
          <ul class="list-group" *ngIf="hasAlarmPhone">
            <li class="list-group-item">
              {{ textAlarmTypes }}
            </li>
          </ul>
          <div class="margin-top-bottom-10">
            <strong *ngIf="!hasAlarmPhone"><i>No Text Alerts Configured</i></strong>
          </div>
          <br />
          <span>Email Addresses in Use (Email Alerts):</span>
          <br />
          <ul class="list-group" *ngIf="hasAlarmEmail">
            <li *ngFor="let email of emails" class="list-group-item">
              {{ email }}
            </li>
          </ul>
          <ul class="list-group" *ngIf="hasAlarmPhone">
            <li class="list-group-item">
              {{ emailAlarmTypes }}
            </li>
          </ul>
          <div class="margin-top-10">
            <strong class="margin-top-bottom-10" *ngIf="!hasAlarmEmail"><i>No Email Alerts Configured</i></strong>
          </div>
          <a routerLink="/MyProfile/Alerts" class="dateLink">Manage My Alerts</a>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-md-12">
    <div class="panel panel-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-question-circle payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">FAQs</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body status-content">
          <ul class="faqUL">
            <li><a class="auth-row-a" routerLink="/CustService/FAQs"><b>To View Many Frequently Asked Questions Click Here. </b></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/status-container/status-container.component.html